// extracted by mini-css-extract-plugin
export default {"container":"_404_container__HKO46","heading":"_404_heading__bQWB6"};